namespace GeniuzPOS.InitialData {
    export interface PsDebitCardRow {
        Id?: number;
        DebitCardType?: string;
        DebitCardName?: string;
        ProdImageLink?: string;
        IsActive?: number;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
    }

    export namespace PsDebitCardRow {
        export const idProperty = 'DebitCardType';
        export const nameProperty = 'DebitCardName';
        export const localTextPrefix = 'InitialData.PsDebitCard';
        export const lookupKey = 'InitialData.PsDebitCard';

        export function getLookup(): Q.Lookup<PsDebitCardRow> {
            return Q.getLookup<PsDebitCardRow>('InitialData.PsDebitCard');
        }
        export const deletePermission = '1POSBASE:ข้อมูลอ้างอิง:ประเภทการรับเงิน,คูปอง:ประเภทบัตรเดบิต:Delete';
        export const insertPermission = '1POSBASE:ข้อมูลอ้างอิง:ประเภทการรับเงิน,คูปอง:ประเภทบัตรเดบิต:Modify';
        export const readPermission = '1POSBASE:ข้อมูลอ้างอิง:ประเภทการรับเงิน,คูปอง:ประเภทบัตรเดบิต:View';
        export const updatePermission = '1POSBASE:ข้อมูลอ้างอิง:ประเภทการรับเงิน,คูปอง:ประเภทบัตรเดบิต:Modify';

        export declare const enum Fields {
            Id = "Id",
            DebitCardType = "DebitCardType",
            DebitCardName = "DebitCardName",
            ProdImageLink = "ProdImageLink",
            IsActive = "IsActive",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate"
        }
    }
}
